import { render, staticRenderFns } from "./SalesDetail.vue?vue&type=template&id=3e584c28&scoped=true"
import script from "./SalesDetail.vue?vue&type=script&lang=js"
export * from "./SalesDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesDetail.vue?vue&type=style&index=0&id=3e584c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e584c28",
  null
  
)

export default component.exports